import { render, staticRenderFns } from "./change-password-dialog.vue?vue&type=template&id=47da96ac&"
import script from "./change-password-dialog.vue?vue&type=script&lang=js&"
export * from "./change-password-dialog.vue?vue&type=script&lang=js&"
import style0 from "./change-password-dialog.vue?vue&type=style&index=0&id=47da96ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports